export default {
  handleisEmpty(obj:any) {
    return !Object.keys(obj).length
  },
  handleSetJapaneseCalendar(date:any, dateOptionData:any, locale:any) {

    if (!date) {
      return ''
    }

    date = new Date(date)

    if (!dateOptionData) {
      dateOptionData = {
        era: 'narrow',
      }
    }

    let japaneseDate

    if (!locale) {
      locale = 'ja-JP-u-ca-japanese'

      japaneseDate = new Intl.DateTimeFormat(
        locale,
        dateOptionData
      ).format(date)
    } else {
      japaneseDate = new Intl.DateTimeFormat().format(date)
    }

    return japaneseDate
  },
  handleKanaToHira(str:any) {
    return str.replace(/[\u30a1-\u30f6]/g, function (match:any) {
      const chr = match.charCodeAt(0) - 0x60;
      return String.fromCharCode(chr);
    });
  },
  handleHiraToKana(str:any) {
    return str.replace(/[\u3041-\u3096]/g, function (match:any) {
      const chr = match.charCodeAt(0) + 0x60;
      return String.fromCharCode(chr);
    });
  },
  camelCase(str:any) {
    str = str.charAt(0).toLowerCase() + str.slice(1);
    return str.replace(/[-_](.)/g, function (match:any, group1:any) {
      return group1.toUpperCase();
    });
  },
  snakeCase(str:any) {
    const camel = this.camelCase(str);
    return camel.replace(/[A-Z]/g, function (s:any) {
      return "_" + s.charAt(0).toLowerCase();
    });
  }
}
